module.exports = __webpack_public_path__ + "static/media/mode-d-emploi.dc7932f0.pdf";